import React, { useRef } from 'react'
import { PlanTimeLine } from '../PlanTimeLine'
import {
  BankModalBackground,
  BankModalContainer,
  BankWrapper,
  ClosedModalButton,
} from './style'

const PlanAmountModal = ({ showModal, setShowModal }: any) => {
  const componentRef = useRef<HTMLDivElement>(null)

  const closeModal = (e: any) => {
    if (componentRef.current !== e.target) {
      setShowModal(false)
    }
  }

  return (
    <BankModalContainer>
      {showModal ? (
        <BankModalBackground>
          <BankWrapper>
            <ClosedModalButton onClick={closeModal} />
            <PlanTimeLine />
          </BankWrapper>
        </BankModalBackground>
      ) : null}
    </BankModalContainer>
  )
}

export { PlanAmountModal }
